type SharedWebSocket = {
  ws: WebSocket | null;
};

export const sharedWebSocket: SharedWebSocket = { ws: null };

export const WS_CLOSE_CODE_LOGOUT = 4000;

export const closeSocket = () => {
  sharedWebSocket.ws?.close(WS_CLOSE_CODE_LOGOUT);
};
